import React from 'react'
import {Link} from 'react-router-dom'
import Navbar from './Navbar'
import Getintouch from './Getintouch';
import Subscribe from "./Subscribe";
import Footer from "./Footer";
import "../components/style.css";

const Home = () => {
  return <>
    <Navbar />
    <div className='container mt-5'>
      <div className='row d-flex justify-content-center'>
        <div className='col-md-6 text-center'>
          <h1 className='display-2'>REIMAGINING<br/>TECHNOLOGY<br/>FUTURES</h1>
        </div>
        <div className='col-md-10 text-center my-5'>
          <p>Welcome to VertoX Labs! We are a team of socially aware and climate conscious individuals, all having a shared vision for better future. We believe that our unique technology solutions have the potential to become a major disruptor in the spaces of environmental waste handling and smart diagnostics. Would you like to find out more? Explore our website today.</p>
          <Link to="/getintouch" className='btn btn-outline-dark mt-5'>Get in Touch</Link>
        </div>
      </div>
    </div>

    
    <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
      <div className="carousel-indicators">
        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 4"></button>
        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="4" aria-label="Slide 5"></button>
      </div>
      <div className="carousel-inner">
        <div className="carousel-item active">
          <img 
           src={ require("../assets/images/the.jpg")} className="d-block w-100" alt="..."/>
        </div>
        <div className="carousel-item">
          <img src={require("../assets/images/c1.jpg")} className="d-block w-100" alt="..."/>
        </div>
        <div className="carousel-item">
          <img src={require("../assets/images/c2.jpg")} className="d-block w-100" alt="..."/>
        </div>
        <div className="carousel-item">
          <img src={require("../assets/images/c3.jpg")} className="d-block w-100" alt="..."/>
        </div>
        <div className="carousel-item">
          <img src={require("../assets/images/c4.jpg")} className="d-block w-100" alt="..."/>
        </div>
      </div>
      <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Previous</span>
      </button>
      <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Next</span>
      </button>
    </div>
   

    <div className={"container-fluid"}>
      <div className={"row my-4"}>
        <div className={"col-md-6"}>
          <img src={require("../assets/images/img1.jpg")} className="d-block w-100 article-img" alt="..."/>
        </div>
        <div className={"col-md-6 d-flex justify-content-center align-items-center text-center "}>
          <div className={"bg-warning p-5"}>
            <h1 className={"display-5 my-5"}>
            WHO WE ARE
            </h1>
            <div className={"px-5 "}>
              <p className={"fs-5"}>
              A bunch of determined and passionate folks designing solutions of the future, today.
              </p>
              <p className={"fs-5"}>
              We’re a young group of first generation entrepreneurs working on ideas backed with groundbreaking technologies to contribute<br/>towards a better tomorrow.
              </p>
              <p className={"fs-5"}>
              At VertoX Labs, we believe that the right understanding and technological edge can lead companies towards a responsive and empathetic<br/>future catering to both the planet and it's people.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className={"row my-4"}>
      <div className={"col-md-6 d-flex justify-content-center align-items-center text-center "}>
          <div className={"bg-warning p-5"}>
            <h1 className={"display-5 my-5"}>
            WATER BODY<br/>RESTORATION
            </h1>
            <div className={"px-5"}>
              <p className={"fs-5 px-5"}>
              At VertoX Labs, our comprehensive technological solutions help rejuvenate water bodies affected by invasive weeds as well as process the waste collected into unique value chain for circularity. In order to empower communities to do better, we are continually building upon our technology, so stay in touch to learn about latest deployments on the field. For a demo, contact us today.
              </p>
            </div>
          </div>
        </div>
        <div className={"col-md-6"}>
          <img src={require("../assets/images/img2.jpg")} className="d-block w-100 article-img" alt="..."/>
        </div>
      </div>
      <div className={"row my-4"}>
        <div className={"col-md-6"}>
          <img src={require("../assets/images/img3.jpg")} className="d-block w-100 article-img" alt="..."/>
        </div>
        <div className={"col-md-6 d-flex justify-content-center align-items-center text-center "}>
          <div className={"bg-warning p-5"}>
            <h1 className={"display-5 my-5"}>
            WHO WE ARE
            </h1>
            <div className={"px-5"}>
              <p className={"fs-4 fw-bold fst-italic"}>
              No-prick smart diagnostic device for detection of iron deficiency 
              </p>
              <p className={"fs-5"}>
              A non-invasive device that is able to detect low iron levels in patients without the need for lab testing. The inspiration for this idea comes from our personal experiences of several women in our lives who've experienced anaemia at various stages of lives.
              </p>
              <p className={"fs-5"}>
              In rural India, the occurrence of iron deficiency related illness is high and detection rates are low due to paucity of lab testing facilities. Furthermore, the application of a non-invasive methodology reduces the risk of infection for both patients and primary healthcare workers.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className={"container mt-5 pt-5"}>
      <div className={"row"}>
        <div className={"text-center text-secondary"}>
          <h1 className={"fs-2 mb-4"}>"The best way to predict the future is to create it"</h1>
          <p className={"lead"}>Abraham Lincoln</p>
          
        </div>
      </div>
    </div>

    <Getintouch />

    <div className={"container my-5 py-5"}>
      <div className={"row"}>
        <div className={"text-center text-secondary my-5"}>
          <h1 className={"fs-2 mb-4"}>Posts Are Coming Soon</h1>
          <p className={"lead"}>Stay tuned...</p>
        </div>
      </div>
    </div>

    <Subscribe />
    <Footer />
  </>
}

export default Home